import React from 'react';
import EventFlights from './EventFlights/EventFlights';
import EventHotels from './EventHotels/EventHotels';

export default ({
  eventData = {}
}) => {
  return (
    <div>
      <EventFlights eventData={eventData} />
      <EventHotels eventData={eventData} />
    </div>
  )
}